export const IconBellRing = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 14H10"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.51249 6.99995C3.51249 6.41064 3.62857 5.82711 3.85408 5.28266C4.0796 4.73821 4.41015 4.24351 4.82685 3.82681C5.24356 3.41011 5.73825 3.07956 6.2827 2.85404C6.82715 2.62852 7.41069 2.51245 7.99999 2.51245C8.5893 2.51245 9.17284 2.62852 9.71729 2.85404C10.2617 3.07956 10.7564 3.41011 11.1731 3.82681C11.5898 4.24351 11.9204 4.73821 12.1459 5.28266C12.3714 5.82711 12.4875 6.41064 12.4875 6.99995V6.99995C12.4875 9.23745 12.9562 10.5375 13.3687 11.25C13.4126 11.3258 13.4357 11.4119 13.4357 11.4995C13.4358 11.5871 13.4129 11.6732 13.3692 11.7492C13.3255 11.8251 13.2626 11.8883 13.1869 11.9323C13.1111 11.9763 13.0251 11.9996 12.9375 12H3.06249C2.97488 11.9996 2.88888 11.9763 2.81311 11.9323C2.73735 11.8883 2.67448 11.8251 2.6308 11.7492C2.58713 11.6732 2.56418 11.5871 2.56425 11.4995C2.56433 11.4119 2.58743 11.3258 2.63124 11.25C3.04374 10.5375 3.51249 9.23745 3.51249 6.99995Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4625 1.5C12.4805 2.14263 13.3022 3.05292 13.8375 4.13125"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.16251 4.13125C2.69783 3.05292 3.51947 2.14263 4.53751 1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
